import { request } from '../boot/request';

export const getStoreSEO = params => {
  params = params || {};
  return request({
    url: '/storeSeo',
    method: 'GET',
    params,
  });
};

export const getRecommend = params => request({
  url: '/recommend',
  method: 'GET',
  params
})
